import { Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { AgentDetailsNavTitle } from "../../../constants/NavBarConst";
import { callAgentList } from "../../agentlist/redux/AgentAction";
import { Modal } from "../../common/Modal1";
import * as actions from "../redux/MemberAction";
import { EditMemberDialog } from "./EditMemberDialog";
import "./memberList.css";
import { ProceedDialog } from "./ProceedDialog";

export const MemberList = ({
  selMemberId,
  currentAgentId,
  currentMemberPage,
  isMemberDetailsVisible,
  memberSettingPermission,
  onClose,
  isAgent,
  onSuccessUpdate,
}) => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const [nickname, setNickname] = useState("");
  const [password, setPassword] = useState("");
  const [viplevel, setViplevel] = useState("");
  const [selectedNav, setSelectedNav] = useState(AgentDetailsNavTitle.INFO);
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [editButton, setEditButton] = useState(false);
  const memberState = useSelector(({ member }) => member, shallowEqual);
  const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

  useEffect(() => {
    if (selMemberId) {
      const queryParams = {
        action: "memberdetail",
        memberid: selMemberId,
      };
      dispatch(actions.callMemberList(queryParams)).then((resp) => {
        resp = resp.data;
        setViplevel(
          resp.memberVipLevelLists.find(
            (memberVipLevel) => memberVipLevel.selected === "true"
          )?.viplevel
        );
      });

      return () => {
        setSelectedNav(AgentDetailsNavTitle.INFO);
      };
    }
  }, [selMemberId]);

  useEffect(() => {
    if (memberState && memberState.memberLists) {
      setPassword(memberState.memberLists.password);
      setNickname(memberState.memberLists.nickname);
    }
  }, [memberState]);

  const handleSwitchChange = (checked, member) => {
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionUpdateThisUserStatus" }),
      showCancelButton: true,
      onConfirm: () => {
        const updateQueryParams = {
          action: "updatememberstatus",
          memberid: member,
        };
        dispatch(actions.updateMemberStatus(updateQueryParams))
          .then(() => {
            const queryParams = {
              action: "memberdetail",
              memberid: selMemberId,
            };
            dispatch(actions.callMemberList(queryParams));
          })
          .catch((error) => {
            console.error("Error updating Member status:", error);
          });
      },
    });
  };

  const handleNicknameChange = (e) => {
    setNickname(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleClose = () => {
    onClose();
    onSuccessUpdate?.();
    if (!onSuccessUpdate) {
      const queryParams = {
        action: "agentmemberlist",
        selagentid: currentAgentId,
        agentpagenum: "0",
        memberpagenum: currentMemberPage,
      };
      dispatch(callAgentList(queryParams));
    }
  };
  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="memberDetailsModal"
        title={intl.formatMessage({ id: "memberDetails" })}
        dismissBtnRef={dismissBtnRef}
        isVisible={isMemberDetailsVisible}
        onClose={handleClose}
      >
        <SweetAlert2
          customClass="custom-swal"
          onResolve={() => {
            setSwalProps({});
          }}
          {...swalProps}
        />
        <EditMemberDialog
          setSwalProps={setSwalProps}
          memberId={selMemberId}
          nickname={nickname}
          password={password}
          viplevel={viplevel}
          isVisible={isEditModalVisible}
          isAgent={isAgent}
          setEditButton={setEditButton}
          onClose={() => setEditModalVisible(false)}
        />
        <ProceedDialog
          setSwalProps={setSwalProps}
          show={show}
          setShow={setShow}
          selmemberid={selMemberId}
          closeParentModal={() => {
            handleClose();
            const queryParams = {
              action: "memberdetail",
              memberid: selMemberId,
            };
            dispatch(actions.callMemberList(queryParams));
          }}
        />
        <div className="d-flex">
          {Object.entries(AgentDetailsNavTitle)
            .filter(([_, value]) => isMM6MM || value !== "telegram")
            .map(([key, value]) => (
              <h6
                style={{
                  color: selectedNav === value ? "#0080FF" : "",
                  borderBottom: selectedNav === value ? "2px solid #0080FF" : "",
                  padding: "10px",
                  cursor: "pointer",
                }}
                className="text-font3"
                onClick={() => setSelectedNav(value)}
                key={key}
              >
                {intl.formatMessage({ id: value })}
              </h6>
            ))}
        </div>
        {selectedNav === AgentDetailsNavTitle.INFO && (
          <div>
            <div
              className="d-flex"
              style={{
                overflowX: "auto",
                margin: "10px auto",
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              <div className="d-flex flex-column gap-2 col-12 px-4">
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "username" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.username}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "nickname" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  {editButton === true ? (
                    <div className=" text-start col">
                      <input
                        type="text"
                        style={{
                          borderColor: "rgba(175, 164, 164, 0.4)",
                          borderRadius: "5px",
                          width: "100%"
                        }}
                        placeholder={memberState.memberLists?.nickname}
                        onChange={handleNicknameChange}
                      />
                    </div>
                  ) : (
                    <div className="text-start col">
                      {memberState.memberLists?.nickname}
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "password" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  {editButton === true ? (
                    <div className="text-start col">
                      <input
                        type="text"
                        style={{
                          borderColor: "rgba(175, 164, 164, 0.4)",
                          borderRadius: "5px",
                          width: "100%"
                        }}
                        placeholder={memberState.memberLists?.password}
                        onChange={handlePasswordChange}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^a-zA-Z0-9]/g,
                            ""
                          );
                        }}
                      />
                    </div>
                  ) : (
                    <div className="text-start col">
                      {memberState.memberLists?.password}
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "ipaddress" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.ipaddress === ""
                      ? "-"
                      : memberState.memberLists?.ipaddress}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "inviteby" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.inviteby !== ""
                      ? memberState.memberLists?.inviteby
                      : "-"}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "status" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  {memberSettingPermission === "true" ? (
                    <div className="text-start col">
                      <Switch
                        checked={memberState.memberLists?.status === "active"}
                        onChange={(checked) =>
                          handleSwitchChange(
                            checked,
                            memberState.memberLists?.memberid
                          )
                        }
                      />
                    </div>
                  ) : (
                    <div className="text-start col">
                      {memberState.memberLists?.status}
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "regdate" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.regdate}
                  </div>
                </div>
                {!isMM6MM && <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "inviteByVip" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.invitebyvipusername !== ""
                      ? memberState.memberLists?.invitebyvipusername
                      : "-"}
                  </div>
                </div>}
                {!isMM6MM &&
                  <div className="d-flex align-items-center">
                    <div className="text-start pe-1 col-5">
                      {intl.formatMessage({ id: "vipLevel" })}
                    </div>
                    <div className="text-center col-1">:</div>
                    {editButton === true ? (
                      <div className="text-start col">
                        <select
                          type="text"
                          style={{
                            borderColor: "rgba(175, 164, 164, 0.4)",
                            borderRadius: "5px",
                            width: "100%"
                          }}
                          onChange={(e) => setViplevel(e.target.value)}
                          value={viplevel}
                        >
                          {memberState.memberLists?.memberVipLevelLists.map(
                            (memberVipLevel) => (
                              <option
                                value={memberVipLevel.viplevel}
                                key={memberVipLevel.viplevel}
                              >
                                {memberVipLevel.viplevel}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    ) : (
                      <div className="text-start col">
                        {
                          memberState.memberLists?.memberVipLevelLists.find(
                            (memberVipLevel) => memberVipLevel.selected === "true"
                          )?.viplevel
                        }
                      </div>
                    )}
                  </div>}
              </div>
            </div>
            {memberSettingPermission === "true" &&
              (editButton === true ? (
                <div className="p-3 d-flex justify-content-evenly">
                  <button
                    className="btn btn-success px-3"
                    onClick={() => {
                      setEditModalVisible(true);
                    }}
                  >
                    {intl.formatMessage({ id: "submit" })}
                  </button>
                  <button
                    className="btn btn-danger px-3"
                    onClick={() => {
                      setEditButton(false);
                    }}
                  >
                    {intl.formatMessage({ id: "cancel" })}
                  </button>
                </div>
              ) : (
                <div className="editButton p-3">
                  <button
                    className="btn btn-primary px-3"
                    onClick={() => {
                      setEditButton(true);
                    }}
                  >
                    {intl.formatMessage({ id: "edit" })}
                  </button>
                </div>
              ))}
          </div>)}
        {selectedNav === AgentDetailsNavTitle.telegram && (
          <div>
            <div
              className="d-flex"
              style={{
                overflowX: "auto",
                margin: "10px auto",
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              <div className="d-flex flex-column gap-2 col-12 px-4">
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "username" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.teleusername}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "fullName" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.telefullname}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="text-start pe-1 col-5">
                    {intl.formatMessage({ id: "phoneNo" })}
                  </div>
                  <div className="text-center col-1">:</div>
                  <div className="text-start col">
                    {memberState.memberLists?.teletelno}
                  </div>
                </div>
              </div>
            </div>
            {memberState.memberLists?.teletelno && (
              <div className="editButton p-3">
                <button
                  className="btn btn-danger px-3"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  {intl.formatMessage({ id: "unbind" })}
                </button>
              </div>
            )}
          </div>)}
      </Modal>
    </div>
  );
};
